import React , { useCallback , useState} from 'react';
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { LayoutChangeEvent } from "react-native"
import FastImage from 'react-native-fast-image';
import Theme from '../../theme';
import { SkeletonLoader } from '../../ui/components';
import { LinearGradient } from '../../ui/components/LinearGradient';
import { defaultScale } from '../../utils/scaling';
interface IMealCardProps {
  cals: string;
  fat: string;
  protein: string;
  carbs: string;
  displayName: string;
  urlForDesktopImage: string;
  prepTime: string;
  hasMarginTop: boolean;
  mealChanged: (mealId: string, meals: any[]) => void;
  t: (str: string, object?: {[key: string]: string}) => string;
}

const MacrosValue = ({ value, label, hasBorder = true }) => {
  const roundedValue = Math.round(parseFloat(value));
  return (
    <View style={[styles.macrosValue, hasBorder && styles.macrosValueBorder]}>
      <Text style={[Theme.textStyle.bodyCopyBold, { textAlign: 'center' }]}>
        {roundedValue}
      </Text>
      <Text style={[Theme.textStyle.small, { textAlign: 'center' }]}>
        {label}
      </Text>
    </View>
  );
};

const MealMacrosRow = ({ cals, carbs, fat, protein, prepTime , t}) => {
  return (
    <View style={styles.mealMacrosRowContainer}>
      { prepTime && <View>
       <Text style={Theme.textStyle.bodyCopyBold}>{t('prepMins', {mins: prepTime})}</Text>
       <Text style={Theme.textStyle.small}>{t('prepTime')}</Text>
      </View>}
      <View style={styles.mealMacrosRow}>
        <MacrosValue value={cals} label={'Cals'} />
        <MacrosValue value={fat} label={'Fat'} />
        <MacrosValue value={carbs} label={'Carbs'} />
        <MacrosValue value={protein} label={'Protein'} hasBorder={false} />
      </View>
    </View>
  );
};

export const MealSelectionCard = React.memo(({
  urlForDesktopImage,
  displayName,
  cals,
  fat,
  protein,
  carbs,
  mealChanged,
  hasMarginTop,
  prepTime,
  t,
}: IMealCardProps) => {
  const [isLoadingImage, setIsLoadingImage] = useState(true);
  const [imageContainerHeight, setImageContainerHeight] = useState(150);
  const onLayout = useCallback((e: LayoutChangeEvent ) => {
    const aspectRatio = 2.2;
    setImageContainerHeight(e.nativeEvent.layout.width / aspectRatio);
  }, []);

  return (
    <>
      <View style={{ marginTop: hasMarginTop ? defaultScale(15) : 0, backgroundColor: Theme.WHITE }}>
        <TouchableOpacity style={{height: imageContainerHeight, width: '100%'}}
         onPress={mealChanged} onLayout={onLayout} >
          <FastImage
            source={{ uri: urlForDesktopImage }}
            style={styles.imageStyle}
            resizeMode={FastImage.resizeMode.cover}
            onLoadStart={() => {
              setIsLoadingImage(true);
            }}
            onLoadEnd={() => {
              setIsLoadingImage(false);
            }}
            //using fallback until this pr is merged: https://github.com/DylanVann/react-native-fast-image/pull/867
            fallback={true}
          >
          </FastImage>
          { <>
              <LinearGradient
                colors={['transparent', Theme.BLACK]}
                style={[styles.gradient]}
                webClassName='meal-selection-card-gradient'
              />
              <View style={styles.displayNameContainer}>
                <Text style={styles.displayName}>{displayName}</Text>
              </View>
            </>}
          {isLoadingImage && <SkeletonLoader containerStyle={styles.loaderContainer}/>}
        </TouchableOpacity>
        <MealMacrosRow cals={cals} fat={fat} carbs={carbs} protein={protein} prepTime={prepTime} t={t} />
      </View>

    </>
  );
});

const styles = StyleSheet.create({
  imageStyle: {
    width: '100%',
    height: '100%',
    },
  displayName: {
    ...Theme.textStyle.heading2,
    color: Theme.WHITE,
    paddingLeft: defaultScale(10),
    paddingBottom: defaultScale(10),
  },
  displayNameContainer: {
    height: '100%',
    position: 'absolute',
    justifyContent: 'flex-end',
  },
  gradient: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    opacity: 0.6,
    height: '25%',
  },
  macrosValue: {
    flexDirection: 'column',
    flex: 1,
  },
  mealMacrosRow: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
    width: '65%',
  },
  mealMacrosRowContainer: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginVertical: defaultScale(10),
    marginLeft: defaultScale(10)
  },
  macrosValueBorder: {
    borderRightWidth: 1,
    borderColor: '#E9E9E9',
  },
  loaderContainer : {
    height: '100%',
    width: '100%',
    position: 'absolute',
  },
});
